var generateStyle = function generateStyle(componentTheme) {
  return {
    root: {
      marginTop: componentTheme.rootMargin,
      /* will look lopsided with the numeric value otherwise */
      paddingLeft: componentTheme.rootPadding
    }
  };
};
export default generateStyle;